import Laravel from "../../../common/technologies/laravel";
import Sendgrid from "../../../common/technologies/sendgrid";
import Redis from "../../../common/technologies/redis";
import Docker from "../../../common/technologies/docker";
import Sns from "../../../common/technologies/sns";
import MongoDb from "../../../common/technologies/mongodb";
import MySQL from "../../../common/technologies/mysql";

function Dbac() {
  return (
    <div className={'portfolio-modal'}>
      <h1>DBAC</h1>
      <h4>Overview</h4>
      <p>
        The system allows users to create bots to play baccarat.
        Users can specify the logic and betting tactics for each bot, as long as when the bot should stop playing.
        The system retrieves the result for each turns from other service and calculate the earning for each bots.
      </p>
      <h4>The difficult parts</h4>
      <ul>
        <li>Handle enormous amount of bots (approximately 30000 to 100000 bots per turn), so there will be a lot of logic need to be handled in 1 turn (time of one turn will be 45 seconds), all the money of the bots must be calculated before next turn.</li>
        <li>Optimize the performance of database queries, working with a lot of data (There will be about 12.000.000 new betting history per day)</li>
        <li>Delete old data</li>
        <li>Handle logs to trace when there is any problem</li>
      </ul>
      <h4>My roles and responsibilities</h4>
      <ul>
        <li>Responsible for logic calculating betting results, delete data and log data</li>
      </ul>
      <h4>Technologies used</h4>
      <div className={'project-technologies'}>
        <Laravel />
        <Sendgrid />
        <Redis />
        <Docker />
        <Sns />
        <MongoDb />
        <MySQL />
      </div>
      <h4>What I learnt from this project</h4>
      <ul>
        <li>Working with SNS of AWS, handle retry mechanism of this service</li>
        <li>Optimize logic</li>
        <li>Handle large data in mongo, how to increase performance when insert a lot of new data and remove old data.</li>
      </ul>
    </div>
  )
}

export default Dbac;
